module ChromeFixes {
  interface ITextAreaState {
    jqueryElement: JQuery<HTMLElement>,
    value: string,
    maxLength: number,
    valueLength: number
  }

  export function construct() {
    //Chrome counts Windows carriage returns (\r\n) as a single characters when typing.
    //But during form validation it counts as 2.
    //So then you can enter more than the max number of characters and Chrome won't let you submit the form.
    //BUT EVEN WORSE IT WON'T GIVE ERROR MESSAGING FOR THIS ISSUE.
    const textareaMaxLength = $('textarea[maxlength]');

    textareaMaxLength.keypress(function () {
      const state = getTextareaState(this);

      if (state.valueLength >= state.maxLength) {
        return false;
      }
    });

    //Prevent pasting in characters above the effective limit but below flawed client side limit.
    textareaMaxLength.keyup(function () {
      const state = getTextareaState(this);

      if (state.valueLength > state.maxLength) {
        const lineBreaks = getNumberOfLineBreaks(state.value);
        const adjustedMaxLength = state.maxLength - lineBreaks;
        const adjustedValue = state.value.substring(0, adjustedMaxLength);
        const adjustedTrimmedValue = adjustedValue.trim();
        state.jqueryElement.val(adjustedTrimmedValue);
      }
    });
  }

  function getTextareaState(htmlElement: HTMLElement): ITextAreaState {
    const jqueryElement = $(htmlElement);
    const value = jqueryElement.val().toString();
    const maxLength = parseInt(jqueryElement.attr("maxlength"));
    const valueLength = getRealTextAreaValueLength(value);
    return {
      jqueryElement: jqueryElement,
      value: value,
      maxLength: maxLength,
      valueLength: valueLength
    };
  }

  function getRealTextAreaValueLength(input: string) {
    const lineBreaks = getNumberOfLineBreaks(input);
    return input.length + lineBreaks;
  }

  function getNumberOfLineBreaks(input: string) {
    const newLines = input.match(/(\r\n|\n|\r)/g);
    if (newLines == null) {
      return 0;
    }
    return newLines.length;
  }
}